module.exports = __webpack_public_path__ + "static/long-line-a50b083007eab61563250cf1e66a54d0.svg";